import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Select from 'react-select';
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';

class ScheduleGroupStaffs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      number: 0,
      schedule_group: {},
      schedule_group_staffs: [],
    };

    this.addCaptain = this.addCaptain.bind(this);
    this.addCopilot = this.addCopilot.bind(this);
    this.addFlightAttendant = this.addFlightAttendant.bind(this);
    this.deleteGroup = this.deleteGroup.bind(this);
    this.editGroup = this.editGroup.bind(this);
    this.deleteGroupStaff = this.deleteGroupStaff.bind(this);
    this.setFinish = this.setFinish.bind(this);

    this.locale = getLocale();
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.schedule_group.id !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        schedule_group: newProps.schedule_group,
        schedule_group_staffs: newProps.schedule_group.schedule_group_staffs,
        start: newProps.schedule_group.start_str,
        finish: newProps.schedule_group.finish_str,
        schedule_initial_id: newProps.schedule_group.schedule_initial_id,
        captains_select: newProps.captains_select,
        copilots_select: newProps.copilots_select,
        flight_attendants_select: newProps.flight_attendants_select,
        schedule_initials_select: newProps.schedule_initials_select,
        number: newProps.number,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  setFinish(event) {
    var data = new Date();
    var day = data.getDate();
    if (day < 10 ) {
      day = '0' + day;
    }
    var month = (data.getMonth()+1);
    if (month < 10 ) {
      month = '0' + month;
    }
    var hours = data.getHours();
    if (hours < 10 ) {
      hours = '0' + hours;
    }
    var minutes = data.getMinutes();
    if (minutes < 10 ) {
      minutes = '0' + minutes;
    }
    var finish = day + '/' + (month) + '/' + data.getFullYear() + ' ' + hours + ':' + minutes;

    this.setState({finish: finish});
  }
  // Fetch salvando a edição
  addCaptain(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_id: this.state.schedule_group.schedule_id,
      schedule_group_id: this.state.schedule_group.id,
      staff_id: this.state.captain_id,
      role: 'captain',
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao/grupo/tripulante', { method: 'post', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  addCopilot(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_id: this.state.schedule_group.schedule_id,
      schedule_group_id: this.state.schedule_group.id,
      staff_id: this.state.copilot_id,
      role: 'copilot',
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao/grupo/tripulante', { method: 'post', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  addFlightAttendant(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_id: this.state.schedule_group.schedule_id,
      schedule_group_id: this.state.schedule_group.id,
      staff_id: this.state.flight_attendant_id,
      role: 'flight_attendant',
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao/grupo/tripulante', { method: 'post', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  deleteGroupStaff(id) {
    if(window.confirm(this.locale.Escalas.EditarEscalaDiaria.deletarTripulante)){
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/programacao/grupo/tripulante', { method: 'delete', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteGroup(id) {
    if(window.confirm(this.locale.Escalas.EditarEscalaDiaria.deletarGrupo)){
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/programacao/grupo', { method: 'delete', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  editGroup(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.schedule_group.id,
      start: this.state.start,
      finish: this.state.finish,
      schedule_initial_id: this.state.schedule_initial_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao/grupo', { method: 'put', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    var sg = this.state.schedule_group;

    var initial = '';
    if (typeof sg.schedule_initial !== 'undefined' && sg.schedule_initial !== null) {
      initial = sg.schedule_initial.name;
    }
    return (
    <div>
      <RequestApi ref={'request_api'} />
      <h4 className="pull-left">{this.locale.Escalas.EditarEscalaDiaria.tituloGrupoAs(this.state.number, sg.start_str, sg.finish_str)} - {initial}</h4>
      <button onClick={() => {self.deleteGroup(sg.id)}} className="btn btn-danger pull-right"><i className="fa fa-fw fa-trash"></i></button>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.editGroup}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Escalas.EditarEscalaDiaria.formularioGrupo.HorarioDeApresentacao}:</label>
              <InputMask value={this.state.start}  maskChar={null} name="start" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'start')} placeholder="" required />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Escalas.EditarEscalaDiaria.formularioGrupo.HorarioDeTerminoDaJornada}:</label>
              <InputMask value={this.state.finish}  maskChar={null} name="finish" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'finish')} placeholder="" />
            </div>
          </div>
          <div className="col-md-1">
            <div className="form-group">
              <button type="button" onClick={() => this.setFinish()} className="btn btn-inline btn-default btn-block"><i className="fa fa-fw fa-calendar"></i></button>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Escalas.EditarEscalaDiaria.formularioGrupo.Situacao}:</label>
              <Select
                className="form-field-name"
                name="schedule_initial_id"
                value={this.state.schedule_initial_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'schedule_initial_id')}
                options={this.state.schedule_initials_select}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Escalas.EditarEscalaDiaria.formularioGrupo.botaoEditarGrupo}</button>
          </div>
        </div>
      </form>
      <hr/>
      <div className="row">
        <form onSubmit={this.addCaptain} className="col-md-4">
          <div className="row">
            <div className="col-md-10">
              <div className="form-group">
                <label>{this.locale.Escalas.EditarEscalaDiaria.formularioAdicionarComandante.Comandante}:</label>
                <Select
                className="form-field-name"
                name="captain_id"
                value={self.state.captain_id}
                searchable={true}
                placeholder={''}
                onChange={self.handleSelectChange.bind(self, 'captain_id')}
                options={self.state.captains_select}
                required
                />
              </div>
            </div>
            <div className="col-md-2">
              <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i></button>
            </div>
          </div>
        </form>
        <form onSubmit={this.addCopilot} className="col-md-4">
          <div className="row">
            <div className="col-md-10">
              <div className="form-group">
                <label>{this.locale.Escalas.EditarEscalaDiaria.formularioAdicionarCopiloto.Copiloto}:</label>
                <Select
                className="form-field-name"
                name="copilot_id"
                value={self.state.copilot_id}
                searchable={true}
                placeholder={''}
                onChange={self.handleSelectChange.bind(self, 'copilot_id')}
                options={self.state.copilots_select}
                required
                />
              </div>
            </div>
            <div className="col-md-2">
              <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i></button>
            </div>
          </div>
        </form>
        <form onSubmit={this.addFlightAttendant} className="col-md-4">
          <div className="row">
            <div className="col-md-10">
              <div className="form-group">
                <label>{this.locale.Escalas.EditarEscalaDiaria.formularioAdicionarComissario.Comissario}:</label>
                <Select
                className="form-field-name"
                name="flight_attendant_id"
                value={self.state.flight_attendant_id}
                searchable={true}
                placeholder={''}
                onChange={self.handleSelectChange.bind(self, 'flight_attendant_id')}
                options={self.state.flight_attendants_select}
                required
                />
              </div>
            </div>
            <div className="col-md-2">
              <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i></button>
            </div>
          </div>
        </form>
      </div>
      <hr/>
      <table className="table table-bordered table-hover table-striped">
        <thead>
          <tr>
            <th>{this.locale.Escalas.EditarEscalaDiaria.tabelaGrupo.Tripulante}</th>
            <th>{this.locale.Escalas.EditarEscalaDiaria.tabelaGrupo.Funcao}</th>
            <th className="col-md-1"></th>
          </tr>
        </thead>
        <tbody>
        {Object.keys(this.state.schedule_group_staffs).map(function(ksgs) {
          var sgs = self.state.schedule_group_staffs[ksgs];
          return (
            <tr>
            <td>{sgs.staff.name}</td>
            <td>{sgs.role_str}</td>
            <td className="text-center"><button onClick={() => {self.deleteGroupStaff(sgs.id)}} className="btn btn-danger"><i className="fa fa-fw fa-trash"></i></button></td>
            </tr>
          );
        })}
        </tbody>
      </table>
      <hr/>
    </div>
    );
  }
}

export default ScheduleGroupStaffs;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/ScheduleGroupStaffs.js